<template>
  <div class="element case">
    <div v-if="separator">
      <hr class="my-0 mb-1 case-separator">
    </div>
    <b-button
      class="d-flex justify-content-between"
      :class="{ 'attach-pressed': btnPressed }"
    >
      <div
        class="d-flex align-items-center flex-fill"
        @click="elementSelected"
      >
        <i
          class="far fa-chart-network primary-dark-title mr-2"
          aria-hidden="true"
        />
        <span>{{ caseStudy.casCasenumber }}</span>
        <vtBubble
          v-if="caseStudy.attachmentsCount"
          :number="caseStudy.attachmentsCount"
          :type="false"
          :tooltip="' '+$tc('global.file',2)"
          style="margin-top: 2px"
        />
      </div>
      <div
        v-show="showArrow"
        class="attach-arrow"
        @click="hideChildren = !hideChildren"
      >
        <i
          v-show="hideChildren"
          class="far fa-chevron-down"
          aria-hidden="true"
        />
        <i
          v-show="!hideChildren"
          class="far fa-chevron-up"
          aria-hidden="true"
        />
      </div>
    </b-button>

    <div
      v-for="(sample, sampleIndex) in caseStudy.samples"
      :id="sample.samLabel"
      :key="`sampleIndex${sampleIndex}`"
      class="element samples ml-2"
      :class="{'attach-display': hideChildren}"
    >
      <sample-tree
        ref="sampleTree"
        :case-id="caseStudy.casId"
        :laboratory-id="laboratoryId"
        :sample="sample"
        @child-selected="$emit('child-selected', $event)"
      />
    </div>

    <div
      v-for="complementary in caseStudy.complementaries"
      :id="`complementary${complementary.id}`"
      :key="`complementary${complementary.id}`"
      :class="{'attach-display': hideChildren}"
    >
      <complementary-tree
        ref="complementaryTree"
        :label="`${$tc('diagnosis.btns.complementary')} ${complementary.code}`"
        :laboratory-id="laboratoryId"
        :case-id="entityId"
        :complementary="complementary"
        @child-selected="$emit('child-selected', $event)"
      />
    </div>
  </div>
</template>

<script>
import SampleTree from './SampleTree'
import VtBubble from '@/components/common/VtBubble'
import caseAttachmentService from '@/api/resources/attachment/caseAttachmentService'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
import { CaseOperationGuardMixin } from '@/api/operations/mixins/guards/case-operation-guard.mixin'
import ComplementaryTree from '@/components/attachments/ComplementaryTree'

export default {
    name: 'CaseTree',
    components: {
        VtBubble,
        SampleTree,
        ComplementaryTree
    },
    mixins: [
        CaseOperationGuardMixin
    ],
    props: {
        laboratoryId: { type: Number, required: true },
        caseStudy: { type: Object },
        separator: { type: Boolean, default: true }
    },
    data() {
        return {
            selectedCaseId: null,
            showArrow: true,
            hideChildren: false,
            btnPressed: false,
            attachments: [],
            elementIcon: 'fa-chart-network',
            attachmentEntityType: ATTACHMENT_ENTITY_TYPE.CASE
        }
    },
    computed: {
        entityId() {
            return this.caseStudy.casId
        },
        entityDisplay() {
            return this.caseStudy.casCasenumber
        },
        caseId() {
            return this.caseStudy.casId
        },
        userHasAttachOperation() {
            return this.$_canAttachDocumentToCase()
        },
        canBeAttached() {
            return this.$_canBeDocumentAttachedToCase(this.caseStudy)
        }
    },
    methods: {
        async elementSelected() {
            this.btnPressed = true
            const attachments = await caseAttachmentService.getAttachments(this.laboratoryId, this.entityId)
            this.attachments = attachments.map(attachment => ({
                ...attachment,
                caseId: this.entityId
            }))
            this.$emit('child-selected', this)
        },
        deselect() {
            this.btnPressed = false
        },
        findSampleTree(sampleId) {
            return this.$refs.sampleTree?.find((child) => child.entityId === sampleId)
        },
        findComplementaryTree(complementaryId) {
            return this.$refs.complementaryTree?.find((child) => child.entityId === complementaryId)
        },
        findPortionTree(portionId) {
            if (!this.$refs.sampleTree) {
                return null
            }
            for (const sampleTree of this.$refs.sampleTree) {
                const portionTree = sampleTree.findPortionTree(portionId)
                if (portionTree) {
                    return portionTree
                }
            }
        },
        findSubportionTree(subportionId) {
            if (!this.$refs.sampleTree) {
                return null
            }
            for (const sampleTree of this.$refs.sampleTree) {
                const subportionTree = sampleTree.findSubportionTree(subportionId)
                if (subportionTree) {
                    return subportionTree
                }
            }
        }
    }
}
</script>
